import React from 'react';
import { BadgeVariant } from 'src/components/atoms/Badge/Badge.styles';
import { CategoryDetailsStatusBadge } from './CategoryDetailsPage/CategoryDetailsStatusBadge.styles';
import { FormStatusTab } from './types';

export function statusToBadgeVariant(_status: FormStatusTab): BadgeVariant {
  return 'custom';
}

export function getStatusDisplayText(status: FormStatusTab): string {
  switch (status) {
    case FormStatusTab.ACTIVE:
      return 'Published';
    case FormStatusTab.DRAFTS:
      return 'Draft';
    case FormStatusTab.ARCHIVED:
      return 'Archived';
    case FormStatusTab.UNPUBLISHED:
      return 'Unpublished';
    default:
      return status;
  }
}

export function renderFormManagementStatusBadge(
  status: FormStatusTab,
): React.ReactElement {
  return (
    <CategoryDetailsStatusBadge
      variant={statusToBadgeVariant(status)}
      text={getStatusDisplayText(status)}
      $status={status}
    />
  );
}
